const translations = {
    noBoundariesFound: 'No boundaries found'
};

export default translations;
